








































import { Component, Vue } from "vue-property-decorator";
import DashLine from '@/components/common/edit/DashLine.vue';
import ImageUpload from "@/components/common/edit/ImageUpload.vue";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    "image-upload": ImageUpload,
    "dash-line": DashLine
  }
})
export default class ActivityCourseImage extends Vue {
  @Getter("section") section: any;
  @Getter("version") version!: string;

  @Action("changeSectionInfo") changeSectionInfo!: Function;

  get prizeImageList(): Array<string> {
    let coursePic:string = this.section.coursePic || '';
    return coursePic.split("@").filter((value: string) => {
      if (value) {
        return value;
      }
    });
  }

  // 修改课程图片
  handleChangePrizeImage(imgUrl: string) {
    const payload = {
      value: imgUrl,
      type: "coursePic"
    };
    this.changeSectionInfo(payload);
  }

  // 删除课程图片
  handleDeletePrizeImage() {
    const payload = {
      value: "",
      type: "coursePic"
    };
    this.changeSectionInfo(payload);
  }

  // 修改奖品图片
  handleChangePrizeImage1(imgUrl: string) {
    let coursePic: string = this.section.coursePic;
    coursePic = coursePic + "@" + imgUrl;
    const payload = {
      value: coursePic,
      type: "coursePic"
    };
    this.changeSectionInfo(payload);
  }

  // 删除奖品图片
  handleDeletePrizeImage1(index: number) {
    const prizeImageList = Array.from(this.prizeImageList);
    prizeImageList.splice(index, 1);
    const payload = {
      value: prizeImageList.join("@"),
      type: "coursePic"
    };
    this.changeSectionInfo(payload);
  }
}
